// T&C Templates' customer types, shared by Settings → T&C Templates and
// setup's T&C editor (IDI-626 D4). Iter18 §2.11: four fixed types plus
// "+ Add custom type", stored on the template as slugs.
export const BASE_CUSTOMER_TYPES = [
  { value: 'residential', label: 'Residential' },
  { value: 'residential_remodel', label: 'Residential Remodel' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'commercial_remodel', label: 'Commercial Remodel' },
];

/** Chip label for a stored type: the fixed label, else words capitalised. */
export const typeLabel = (v) => (BASE_CUSTOMER_TYPES.find((o) => o.value === v)?.label
  || String(v).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()));

/** Stored value for a typed custom type ("HOA" → "hoa"). */
export const typeSlug = (label) => String(label).trim().toLowerCase().replace(/\s+/g, '_');
